import {
  call, put, all, select, delay,
} from 'redux-saga/effects';
import {
  apiGetCompanyResponsibilities,
  apiPutCompanyResponsibilities,
} from 'services/api/companyResponsibility';

import { getErrorMessage } from 'utils/filters';

import { Creators as CreatorsResp } from '../ducks/companyResponsibility';
import { Creators as TaskCreators } from '../ducks/task';
import { Creators as UiCreators, growlTypes } from '../ducks/ui';

export function* getResponsibilities() {
  try {
    yield put(UiCreators.showLoader('COMPANY_RESP'));
    const companyId = yield select(state => state.auth.triiderUser.company.id);
    const { responsibility } = yield call(apiGetCompanyResponsibilities, companyId);

    yield all([
      put(CreatorsResp.getResponsibilitiesSuccess(responsibility)),
      put(UiCreators.hideLoader('COMPANY_RESP')),
    ]);
  } catch (error) {
    const message = getErrorMessage(error);
    yield all([
      put(
        UiCreators.growl(message, growlTypes.GROWL_ERROR, {
          error,
        }),
      ),
      put(UiCreators.hideLoader('COMPANY_RESP')),
    ]);
  }
}

export function* setResponsibilities({ payload }) {
  try {
    yield put(UiCreators.showLoader('COMPANY_RESP'));
    const { responsibilitySelected, task_id, ofListTask = false } = payload;

    const companyId = yield select(state => state.auth.triiderUser.company.id);
    const { result } = yield call(apiPutCompanyResponsibilities, companyId, task_id, {
      bucket_id: responsibilitySelected.responsibility_bucket_id,
    });

    yield all([
      ofListTask
        ? put(TaskCreators.updateLastTaskOfListSuccess(result))
        : put(TaskCreators.updateLastTaskSuccess(result)),
      put(UiCreators.hideLoader('COMPANY_RESP')),
      put(UiCreators.growl('Responsável alterado com sucesso!', growlTypes.GROWL_SUCCESS)),
    ]);
  } catch (error) {
    const message = getErrorMessage(error);
    yield all([
      put(
        UiCreators.growl(message, growlTypes.GROWL_ERROR, {
          error,
        }),
      ),
      put(UiCreators.hideLoader('COMPANY_RESP')),
    ]);
  }
}
